import { render, staticRenderFns } from "./TeamTabs.vue?vue&type=template&id=3e894a9e"
import script from "./TeamTabs.vue?vue&type=script&lang=js"
export * from "./TeamTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports